<template>
  <div class="main-container">
    <!-- loading -->
    <div
      v-if="!notFound && !timeout && !consultant"
      class="flex items-center content-center"
      style="height: 100%; font-size: 24px; background: white; flex-direction: column;"
    >
      Loading...
    </div>
    <!-- consultant not found -->
    <div
      v-if="notFound || (!consultant && timeout)"
      class="flex items-center content-center"
      style="height: 100%; font-size: 24px; background: white; flex-direction: column;"
    >
      <div class="tech-jumbotron-img">
        <img src="@/assets/image/consultant_process.png" alt="process" />
      </div>
      Consultant not found!
    </div>
    <!-- consultant review -->
    <div v-if="consultant">
      <div class="main-content-wrap" style="max">
        <div class="main-content-pannel flex flex-col main-content-pannel-t">
          <div class="flex flex-1">
            <div class="flex-2 review-main-content-middle">
              <div class="main-pannel"  v-if="consultant">
                <div class="main-pannel-content">
                  <div class="tech-resume-info flex items-center justify-center">
                    <div class="flex-1">
                      <h3>{{(consultant.name ? consultant.name : consultant.email) | getNameByEmail}}</h3>
                      <p>Location: {{consultant.metro}}</p>
                      <div>
                        <span
                          class="status-pill"
                          :class="{'red' : !consultant.is_active, 'green' : consultant.is_active}"
                        ></span>
                        <span>{{consultant.is_active? 'Active' : 'Inactive'}}</span>
                      </div>
                    </div>
                    <div class="tech-resume-info-avatar">
                      <div class="tech-resume-info-avatar-container">
                        <span
                          v-if="!consultant.photo_url"
                        >{{(consultant.name ? consultant.name : consultant.email) | getFirstLetter}}</span>
                        <img v-else :src="consultant.photo_url" alt />
                      </div>
                    </div>
                  </div>
                  <div class="dashboard-more-info">
                    <div class="review-info-item" v-bind:style="{ maxWidth: `max-width: calc(100vw - 650px)`}" >
                      <label>Email:</label>
                      <p>{{consultant.email ? consultant.email : 'none'}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>Phone Number:</label>
                      <p>{{consultant.phone_number ? consultant.phone_number : 'none'}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>Title:</label>
                      <p>{{consultant.title ? consultant.title : 'none'}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>Address:</label>
                      <p>{{consultant.address ? consultant.address : 'none'}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>Rate:</label>
                      <p>{{consultant.rate ? consultant.rate : 0 | currencyFilter('$', 2)}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>Bio:</label>
                      <p>{{consultant.bio ? consultant.bio : 'none'}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>What kind of work are you looking for?(Part time to fill hours, full-time, off hours, etc):</label>
                      <p>{{apply ? apply.work ? apply.work : 'none' : 'none'}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>Are you open to relocting to another city for a long term 6-12 month project?</label>
                      <p>{{apply ? apply.is_relocation !== (null || undefined) ? apply.is_relocation : 'none' : 'none'}}</p>
                    </div>
                    <div v-if="apply && apply.answers">
                      <div class="review-info-item" v-for="(item, index) in apply.answers" :key="index">
                        <label>{{item.definition}}</label>
                        <p>{{item.answer}}</p>
                      </div>
                    </div>
                    <!-- <div class="review-info-item">
                      <label>You will be assigned a "tier" or "level" in IT support that you will be cleared for. Each "level" of work has an associated pay rate. Are you willing to do work that is below your skill level, even though the pay rate would be lower?</label>
                      <p>{{consultant.application_data ? consultant.application_data.skillLevel ? consultant.application_data.skillLevel : 'none' : 'none'}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>What is your current work situation?</label>
                      <p>{{consultant.application_data ? consultant.application_data.workSituation ? consultant.application_data.workSituation : 'none' : 'none'}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>What type of work are you open to out of the options: full time, part time, and/or short term projects (ad hoc work)?</label>
                      <p>{{consultant.application_data ? consultant.application_data.workTypes ? consultant.application_data.workTypes.join(", ") : 'none' : 'none'}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>What general geographic area are you willing to drive to, to work onsite, without relocating? (please describe specifically using the text below):</label>
                      <p>{{consultant.application_data ? consultant.application_data.geographic ? consultant.application_data.geographic : 'none' : 'none'}}</p>
                    </div>
                    <div class="review-info-item">
                      <label>Put 2 references who have worked with you around a year or longer:</label>
                      <p>{{consultant.application_data ? consultant.application_data.references ? consultant.application_data.references : 'none' : 'none'}}</p>
                    </div> -->
                    <div class="review-info-item" v-for="(info, index) in consultantEditInfo" :key="index">
                      <label>{{info.title}}</label>
                      <p>{{info.content}}</p>
                    </div>
                  </div>
                </div>
                <div class="main-pannel-foot">
                  <ul>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="addInfo"
                        :class="{'active' : editOpen==1 }"
                      >
                        <i class="material-icons-outlined align-middle">add</i>Add Info
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-1">
            <div class="main-pannel m-l-l m-r-l m-b-3l">
              <h3 class="main-pannel-header b-0">
                COMMENTS
                <ul class="main-pannel-header-menu">
                  <li>
                    <a
                      href="javascript:void(0)"
                      @click="addComment"
                      :class="{'active' : editOpen==2 }"
                    >
                      <i class="material-icons-outlined align-middle">add</i>
                      Add comment
                    </a>
                  </li>
                </ul>
              </h3>
              <div class="main-pannel-content p-0">
                <ag-grid-vue
                  style="width: 100%; height: 300px;"
                  class="ag-theme-material"
                  :gridOptions="gridOptions"
                  :columnDefs="columnDefs"
                  @column-resized="onColumnResized"
                  :rowData="consultantComments"
                ></ag-grid-vue>
              </div>
            </div>
          </div>
        </div>
        <transition name="edit-pannel">
          <edit-pannel v-model="editOpen" title>
            <PanelAddInfo
              v-if="editOpen == 1"
              :submitLoading="addInfoSubmitLoading"
              @buttonClick="addInfoButtonClick"
            ></PanelAddInfo>
            <PanelAddComment
              v-if="editOpen == 2"
              :submitLoading="addCommentSubmitLoading"
              @buttonClick="addCommentButtonClick"
            ></PanelAddComment>
          </edit-pannel>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import PanelAddInfo from "@/components/admin/consultantReview/PanelAddInfo.vue";
import PanelAddComment from "@/components/admin/consultantReview/PanelAddComment.vue";
import EditPannel from "@/components/EditPannel.vue";
import { AgGridVue } from "ag-grid-vue";
import { mapState } from "vuex";
import * as utils from "@/utils/utils";
import moment from 'moment';

export default {
  data() {
    return {
      notFound: false,
      timeout: false,
      queryId: null,
      consultant: null,
      apply: null,
      sidebarWidth: null,
      editOpen: null,
      addInfoSubmitLoading: false,
      consultantEditInfo: [],
      addCommentSubmitLoading: false,
      consultantComments: [],

      gridOptions: {},
      columnDefs: null
    }
  },
  components: {
    PanelAddInfo,
    EditPannel,
    AgGridVue,
    PanelAddComment
  },
  watch: {
    consultant: function() {
      if (this.consultant && this.consultant.apply) {
        this.bindApplyData(this.consultant.apply)
      }
      this.consultantEditInfo = this.consultant.edit_info ? this.consultant.edit_info : [];
      this.consultantComments = (this.consultant.comments ? this.consultant.comments.map(item => ({
        ...item, createdString: item.created ? utils.dateformat(item.created, "MM/DD/YYYY HH:mm A") : null})) : []).sort((a, b) => {
          if (!a.created) return 1;
          if (!b.created) return -1;
          return b.created - a.created;
        });
    }
  },
  computed: {
    ...mapState(["user"])
  },
  beforeMount() {
    this.queryId = this.$route.query.id;
    if (this.queryId) {
      this.initColumnDefs();
      this.bindData();
    } else {
      this.notFound = true;
    }
  },
  mounted() {
    setTimeout(() => {
      this.timeout = true;
    }, 8000);
  },
  methods: {
    bindData: function() {
      if (this.queryId) {
        this.$bind(
          "consultant",
          db.collection("consultants").doc(this.queryId)
        );
      }
    },
    bindApplyData: function(applyId) {
      this.$bind(
        "apply",
        db.collection("applies").doc(applyId)
      );
    },
    addInfo: function() {
      this.openEditPanel(1, true);
    },
    openEditPanel: function(action, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
    },
    closeEditPanel: function() {
      this.editOpen = false;
    },
    addInfoButtonClick: function(title, content) {
      this.addInfoSubmitLoading = true;
      const editInfo = this.consultant.edit_info ? this.consultant.edit_info.slice() : [];
      editInfo.push({ title, content });
      db.collection("consultants")
        .doc(this.queryId)
        .update({edit_info: editInfo})
        .then(() => {
          this.closeEditPanel();
          this.$toasted.global.toast_success({ message: "add success" });
        })
        .catch(() => {
          this.$toasted.global.toast_error({ message: "add error" });
        })
        .finally(() => {
          this.addInfoSubmitLoading = false;
        });
    },
    initColumnDefs: function() {
      this.gridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true
        },
        context: {
          componentParent: this
        },
        animateRows: true,
        enableCellTextSelection: true
      };
      this.columnDefs = [
        {
          headerName: "CREATED",
          field: "createdString",
          comparator: utils.dateComparator,
        },
        { headerName: "COMMENTER", field: "commenter" },
        { headerName: "COMMENT", field: "comment", width: 600, cellClass: "cell-wrap-text" }
      ];
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    addComment: function() {
      this.openEditPanel(2, true);
    },
    addCommentButtonClick: function(comment) {
      this.addCommentSubmitLoading = true;
      const comments = this.consultant.comments ? this.consultant.comments.slice() : [];
      comments.push({ commenter: this.user ? this.user.displayName ? this.user.displayName : "" : "", comment, created: Math.floor(moment().valueOf() / 1000) });
      db.collection("consultants")
        .doc(this.queryId)
        .update({comments})
        .then(() => {
          this.closeEditPanel();
          this.$toasted.global.toast_success({ message: "add success" });
        })
        .catch(() => {
          this.$toasted.global.toast_error({ message: "add error" });
        })
        .finally(() => {
          this.addCommentSubmitLoading = false;
        });
    }
  }
}
</script>
